var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLineSingleArrowIcon = function SvgLineSingleArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.001 7.959 9 25.96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "m28.77 6.19-3.183 9.547-6.364-6.364z"
  })));
};

export default SvgLineSingleArrowIcon;